import React, { Component } from "react";
import axios from "axios";
import { connect } from "react-redux";
import Sidebar from "../../components/Sidebar";
import Topbar from "../../components/Topbar";
import Loading from "../../components/Loading";
import { MDBDataTable } from "mdbreact";
import { CSVLink } from "react-csv";
import DatePicker from "react-datepicker";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

const mySwal = withReactContent(Swal);

class TokenPurchaseHistory extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            toggled: false,
            loading: true,
            startDate: "",
            endDate: ""
        };
    }

    componentDidMount() {
        if (!this.props.admin.isAuthenticated || !this.props.admin.admin) {
            this.props.history.push("/admin/dashboard");
        } else {
            axios
                .post("/api/admin/report/token/purchaseHistory", { operatorId: this.props.admin.admin.operatorId }, { headers: { "Content-Type": "application/json", "auth-token": this.props.admin.token } })
                .then(res => {
                    this.setState({
                        ...this.state,
                        data: res.data,
                        loading: false
                    });
                })
                .catch(err => this.props.history.push("/admin/dashboard"));
        }
    }

    handleToggle = () => this.setState({ ...this.state, toggled: !this.state.toggled });

    handleDate = dates => {
        const [start, end] = dates;
        // console.log({start , end});
        this.setState({
            ...this.state,
            startDate: start,
            endDate: end
        });
    };

    handleFilter = e => {
        const { startDate, endDate } = this.state;
        let sendThis = {
            operatorId: this.props.admin.admin.operatorId
        };

        if (startDate && endDate) {
            sendThis.startDate = new Date(startDate).setHours(0, 0, 0, 0);
            sendThis.endDate = new Date(endDate).setHours(23, 59, 59, 999);
        }
        this.setState({
            ...this.state,
            loading: true
        });
        axios
            .post("/api/admin/report/token/purchaseHistory", sendThis, { headers: { "Content-Type": "application/json", "auth-token": this.props.admin.token } })
            .then(res => {
                this.setState({
                    ...this.state,
                    loading: false,
                    data: res.data,
                });
            })
            .catch(err => {
                this.setState({
                    ...this.state,
                    loading: false
                });
                mySwal.fire("Error", err.response.data.error, "error");
            });
    };

    handleReset = e => {
        this.setState({
            ...this.state,
            loading: true,
            startDate: "",
            endDate: ""
        });
      
        axios
            .post("/api/admin/report/token/purchaseHistory", { operatorId: this.props.admin.admin.operatorId }, { headers: { "Content-Type": "application/json", "auth-token": this.props.admin.token } })
            .then(res => {
                this.setState({
                    ...this.state,
                    data: res.data,
                    loading: false
                });
            })
            .catch(err => {
                this.setState({
                    ...this.state,
                    loading: false
                });
                mySwal.fire("Error", err.response.data.error, "error");
            });
    };

    render() {
        let tableData = {
            columns: [
                {
                    label: "User Name",
                    field: "name",
                    sort: "asc"
                },
                {
                    label: "Phone Number",
                    field: "number",
                    sort: "asc"
                },
                {
                    label: "Email Address",
                    field: "email",
                    sort: "asc"
                },
                {
                    label: "Member ID",
                    field: "memberId",
                    sort: "asc"
                },
                {
                    label: "e-Token Purchased (Tokens)",
                    field: "token",
                    sort: "asc"
                },
                {
                    label: "Bought e-Token using (RM)",
                    field: "amount",
                    sort: "asc"
                },
                {
                    label: "Transaction ID",
                    field: "transactionId",
                    sort: "asc"
                },
                {
                    label: "Reference ID",
                    field: "referenceId",
                    sort: "asc"
                },
                {
                    label: "Method",
                    field: "method",
                    sort: "asc"
                },
                {
                    label: "Purchase Date",
                    field: "date",
                    sort: "asc"
                },
                {
                    label: "Status",
                    field: "status",
                    sort: "asc"
                }
            ],
            rows: this.state.data
        };

        let csv = [];

        if (this.state.data) {
            for (let i = 0; i < this.state.data.length; i++) {
                let data = {
                    name: this.state.data[i].name,
                    number: `=""${this.state.data[i].number}""`,
                    email: this.state.data[i].email,
                    memberId: this.state.data[i].memberId,
                    token: this.state.data[i].token,
                    amount: this.state.data[i].amount,
                    transactionId: this.state.data[i].transactionId,
                    referenceId: this.state.data[i].referenceId,
                    method: this.state.data[i].method,
                    date: this.state.data[i].date,
                    status: this.state.data[i].status,
                }
                csv.push(data);
            }
        }

        const csvData = {
            headers: [
                { label: "User Name", key: "name" },
                { label: "Phone Number", key: "number" },
                { label: "Email Address", key: "email" },
                { label: "Member ID", key: "memberId" },
                { label: "e-Token Purchased (Tokens)", key: "token" },
                { label: "Bought e-Token using (RM)", key: "amount" },
                { label: "Transaction ID", key: "transactionId" },
                { label: "Reference ID", key: "referenceId" },
                { label: "Method", key: "method" },
                { label: "Purchase Date", key: "date" },
                { label: "Status", key: "status" }
            ],
            data: csv
        };

        return (
            <div className="admin-page-container">
                <Sidebar toggled={this.state.toggled} setToggled={this.handleToggle} />
                <div className="admin-page">
                    <Topbar handleToggle={this.handleToggle} />
                    <div className="admin-content">
                        <div className="card">
                            <div className="card-header">
                                <h5 className="card-title">e-Token Purchase History</h5>
                            </div>

                            <div className="card-body">
                            <div className="mb-5">
									<h6>Filter</h6>
									<div>
										<label htmlFor="date">Select Date: </label>
										<DatePicker value={`${this.state.startDate ? new Date(this.state.startDate).toLocaleDateString() : ""} - ${this.state.endDate ? new Date(this.state.endDate).toLocaleDateString() : ""}`} onChange={this.handleDate} startDate={this.state.startDate} endDate={this.state.endDate} selectsRange shouldCloseOnSelect={false} />
									</div>

									<div className="d-flex">
										<button onClick={this.handleFilter} className="btn btn-primary btn-inline form-control me-3">
											Filter
										</button>
										<button onClick={this.handleReset} className="btn btn-secondary btn-inline form-control ms-3">
											Reset
										</button>
									</div>
								</div>
                                {
                                    this.state.loading ? (
                                        <Loading />
                                    ) : (
                                        <div>
                                            <MDBDataTable data={tableData} noBottomColumns striped hover responsive bordered />
                                            <div className="d-grid gap-2 d-md-flex justify-content-md-end">
                                                <CSVLink className="btn btn-primary" data={csvData.data} headers={csvData.headers} filename="e-TokenPurchaseHistoryReport.csv" target="_blank">
                                                    Download Report
                                                </CSVLink>
                                            </div>
                                        </div>
                                    )
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        admin: state.admin
    };
};

export default connect(mapStateToProps, null)(TokenPurchaseHistory);